import { j as t } from "../jsx-runtime-ClSzPYp4.js";
import { forwardRef as h } from "react";
import { styled as m } from "styled-components";
import { space as g } from "styled-system";
import I from "../Button/Button.mjs";
import { Box as x } from "../Flexbox/Flexbox.mjs";
import "../index.esm-DOxVcNnO.js";
import y from "../Icon/Icons/AlertIcon.mjs";
import "../Icon/StyledPath.mjs";
import { generateId as j } from "../common/utils/index.mjs";
import S from "../typography/Paragraph/Paragraph.mjs";
import $ from "../typography/Text/Text.mjs";
const w = /* @__PURE__ */ m(x).withConfig({
  componentId: "sc-a35f4f46-0"
})([
  "",
  " ",
  ""
], ({ theme: o }) => o.components.errorSummary.wrapper, g), q = /* @__PURE__ */ m(I).withConfig({
  componentId: "sc-a35f4f46-1"
})([
  "",
  ""
], ({ theme: o }) => o.components.errorSummary.button), C = /* @__PURE__ */ m(y).withConfig({
  componentId: "sc-a35f4f46-2"
})([
  "",
  ""
], ({ theme: o }) => o.components.errorSummary.alertIcon), E = /* @__PURE__ */ m.ul.withConfig({
  componentId: "sc-a35f4f46-3"
})([
  "",
  ""
], ({ theme: o }) => o.components.errorSummary.list), k = (o) => `${o} error${o > 1 ? "s" : ""}`, B = ({ summary: o, items: r }) => o ? typeof o == "function" ? o(r.length) : o : k(r.length), A = ({ onClickError: o, reference: r, event: a }) => {
  if (o)
    o(r, a);
  else {
    const n = typeof r == "string" ? document.querySelector(`[name="${r}"]`) : r == null ? void 0 : r.current;
    n && n.focus();
  }
}, K = /* @__PURE__ */ h(({ summary: o, items: r, onClickError: a, id: n = j(), quantumMetricVisible: s = !1, ...c }, d) => {
  const e = c["data-qa-id"] || "error-summary", l = r && r.length > 0;
  return /* @__PURE__ */ t.jsx(w, {
    ref: d,
    tabIndex: -1,
    role: l ? "alert" : void 0,
    ...c,
    "data-qa-id": e,
    children: l && /* @__PURE__ */ t.jsxs(t.Fragment, {
      children: [
        /* @__PURE__ */ t.jsx(S, {
          "data-qa-id": `${e}-heading-${n}`,
          fontWeight: "medium",
          "data-qm-allow": s,
          children: B({
            summary: o,
            items: r
          })
        }),
        /* @__PURE__ */ t.jsx(E, {
          children: r.map(({ message: f, reference: p }, i) => /* @__PURE__ */ t.jsx("li", {
            children: /* @__PURE__ */ t.jsxs(q, {
              variant: "textLinkInline",
              textSize: "medium",
              "data-qa-id": `${e}-message-${i}-${n}`,
              role: "link",
              onClick: (u) => A({
                onClickError: a,
                reference: p,
                event: u
              }),
              children: [
                /* @__PURE__ */ t.jsx(C, {}),
                /* @__PURE__ */ t.jsx($, {
                  color: "currentColor",
                  "data-qm-allow": s,
                  children: f
                })
              ]
            }, i)
          }, i))
        })
      ]
    })
  });
});
export {
  K as ErrorSummary
};
